"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeMultisendCall = exports.MultisendTransactionOperation = void 0;
const ethers_1 = require("ethers");
const constants_1 = require("../constants");
var MultisendTransactionOperation;
(function (MultisendTransactionOperation) {
    MultisendTransactionOperation[MultisendTransactionOperation["CALL"] = 1] = "CALL";
    MultisendTransactionOperation[MultisendTransactionOperation["DELEGATE_CALL"] = 2] = "DELEGATE_CALL";
})(MultisendTransactionOperation = exports.MultisendTransactionOperation || (exports.MultisendTransactionOperation = {}));
const encodeMultisendCall = (txs) => {
    const calldata = "0x" +
        txs
            .map((tx) => {
            const bytes = ethers_1.utils.arrayify(tx.data);
            return ethers_1.utils
                .solidityPack([
                "uint8",
                "address",
                "uint256",
                "uint256",
                "bytes", // data as bytes
            ], [
                !tx.operation || tx.operation === MultisendTransactionOperation.CALL ? 0 : 1,
                tx.to,
                tx.value ? tx.value : ethers_1.BigNumber.from("0"),
                bytes.length,
                bytes,
            ])
                .slice(2); // remove leading "0x"
        })
            .join("");
    const iface = new ethers_1.utils.Interface(constants_1.MultisendAbi);
    return iface.encodeFunctionData("multiSend", [calldata]);
};
exports.encodeMultisendCall = encodeMultisendCall;
//# sourceMappingURL=multisend.js.map